//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapGetters } from "vuex";
import { debounce } from "quasar";
import FabricSearch from "@/components/q-fabric-search.vue";
import TaskCardMobile from "@/pages/main/views/TaskList/taskCardMobile.vue";
import UnclaimReassignModal from "@/components/tasks/unclaimReassign/unclaimReassignModal.vue";
import TaskFiltersDialog from "@/pages/main/views/TaskList/TaskFiltersDialog.vue";
import TasksUtils from "@/components/UserInterfaces/mixins/tasks-utils";
import { allowAccessibilityColors } from "@/assets/js/appFunc";
import MobileHeader from "@/components/Mobile/MobileHeader.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import {
    TASK_TYPE, TASKS_STATUS, TASK_TYPE_MAPPINGS, PRIORITY_MAPPINGS, TASKS_SORT_OPEN, TASKS_SORT_COMPLETED
} from "./constants";
import AQButton from "../../../../components/Generics/AQButton/AQButton.vue";

export default {
    name: "TaskListMobile",
    components: {
        FabricSearch,
        AQButton,
        TaskCardMobile,
        UnclaimReassignModal,
        TaskFiltersDialog,
        AQRadio,
        AQModal,
        AQMenu,
        AQCheckbox,
        AQChip,
        MobileHeader
    },
    mixins: [TasksUtils],
    data() {
        return {
            openUnclaimReassignModal: false,
            tasksChecked: false,
            searchTasks: "",
            sortModel: false,
            processesDialog: false,
            allStatuses: false,
            taskType: false,
            allApplications: false,
            allProcesses: false,
            allUsers: false,
            allGroups: false,
            menuOpened: false,
            reassignAction: false,
            targetTypeTaskList: this.$t("tasks.myOpenTasks"),
            tasksTypeDialog: false,
            nameValue: this.$t("tasks.myOpenTasks"),
            tasksTypeNormalUser: [
                this.$t("tasks.myOpenTasks"),
                this.$t("tasks.myCompletedTasks")
            ],
            tasksTypeManager: [
                this.$t("tasks.myOpenTasks"),
                this.$t("tasks.myCompletedTasks"),
                this.$t("tasks.myTeamTasks"),
                this.$t("tasks.myTeamCompletedTasks")
            ],
            taskList: [],
            tasksDisplayPayload: {
                pageSize: 10,
                pageNumber: 0,
                sortBy: "",
                sortType: "",
                groupId: "",
                users: [],
                onlyAvailable: false,
                onlyClaimed: false,
                onlyDelegated: false,
                applications: [],
                processes: [],
                statuses: [],
                searchValue: "",
                type: "myOpenTasks",
                activeTasks: true
            },
            isOpen: true,
            isTeam: false,
            totalCount: 0,
            normalFont: false,
            loading: false,
            localShowFilters: false,
            sortByDataOpen: TASKS_SORT_OPEN,
            sortByDataCompleted: TASKS_SORT_COMPLETED,
            sortByData: [],
            appsData: [],
            processesData: [],
            dataGroups: [],
            userList: [],
            groupDefaultName: "",
            bulkActions: [{
                label: this.$t("appTasksContainer.UNCLAIM"),
                value: "UNCLAIM"
            },
            {
                label: this.$t("appTasksContainer.REASSIGN"),
                value: "REASSIGN"
            }],
            statusesData: TASKS_STATUS,
            tasksData: TASK_TYPE,
            defaultSortVal: this.$t("tasks.sortBy"),
            defaultAllStatVal: this.$t("appTasksContainer.selectStatuses"),
            defaultAllAppsVal: this.$t("appTasksContainer.applications"),
            defaultAllProcessesVal: this.$t("appTasksContainer.processes"),
            defaultAllUsers: this.$t("appTasksContainer.selectUsers"),
            defaultAllGroups: this.$t("tasks.groupTitle"),
            sortValue: "",
            statusesValue: "",
            taskTypeValue: "",
            applicationsValue: "",
            processesValue: "",
            bulkActionsModel: [],
            usersValue: "",
            groupsValue: "",
            applicationsType: "applications",
            processesType: "processes",
            usersType: "users",
            selectedProcessesToSend: [],
            initialObject: {
                sort: {
                    by: "",
                    type: ""
                },
                sortTypeValue: "",
                sortingSelected: "",
                taskTypeValue: {
                    id: [],
                    name: ""
                },
                statusesValue: {
                    id: [],
                    statusName: ""
                },
                applicationsValue: {
                    id: [],
                    name: ""
                },
                processesValue: {
                    id: [],
                    name: ""
                },
                usersValue: {
                    id: [],
                    name: "",
                    email: []
                },
                groupsValue: {
                    id: "",
                    name: ""
                }
            },
            selectedApplications: {
                id: [],
                name: ""
            },
            selectedProcesses: {
                id: [],
                name: ""
            },
            selectedUsers: {
                id: [],
                name: "",
                email: []
            },
            selectedSort: {
                by: "",
                type: ""
            },
            selectedStatuses: {
                id: [],
                statusesNames: ""
            },
            selectedTasks: {
                id: [],
                tasksNames: ""
            },
            sortingSelected: "",
            selectedGroup: {
                id: "",
                name: ""
            },
            groupsType: "groups",
            sortType: "sort",
            statusesType: "statuses",
            bigDialog: true,
            bulkCheckbox: false,
            entireSelectedTaskList: [],
            tasksTypeData: [],
            bulkTypeSelected: null,
            showButtonBulkUnclaim: false,
            showButtonBulkReassign: false,
            allTasksListIds: [],
            resetSelectedBackground: false,
            bulkCheckboxSelectedTasks: [],
            bulkUnclaimReassignModal: false,
            hasUsers: true,
            hasIndeterminate: false,
            applyAction: {
                label: this.$t("tasks.apply"),
                disabled: false
            },
            hasApps: true,
            hasProcesses: true,
            resetUser: false,
            propApp: {},
            propProcesses: {},
            propTasks: {},
            propSort: {},
            propStatuses: {},
            propUsers: {},
            propGroups: {},
            resetMyFilters: false,
            lastScrollTop: 0,
            elemScroll: 0,
            emptyInitialObject: {
                sort: {
                    by: "",
                    type: ""
                },
                sortTypeValue: "",
                sortingSelected: "",
                taskTypeValue: {
                    id: [],
                    name: ""
                },
                statusesValue: {
                    id: [],
                    statusName: ""
                },
                applicationsValue: {
                    id: [],
                    name: ""
                },
                processesValue: {
                    id: [],
                    name: ""
                },
                usersValue: {
                    id: [],
                    name: "",
                    email: []
                },
                groupsValue: {
                    id: "",
                    name: ""
                }
            },
            appsPayload: {
                pageSize: 50,
                pageNumber: 0,
                searchValue: ""
            }
        };
    },
    computed: {
        ...mapGetters("userProfile", ["userDataDetails", "getUserIsManager"]),
        ...mapGetters("tasks", ["getSelectedTasksFilter", "getSelectedAppName"]),
        checkPlatform() {
            return navigator.userAgent.match("CriOS");
        },
        selectedTasksInfo() {
            const msg = this.entireSelectedTaskList.length ? this.entireSelectedTaskList.length : this.$t("appTasksContainer.none");
            return `${msg} ${this.$t("appTasksContainer.selected")}`;
        },
        bulkActionsOptions() {
            let localOptions = [];
            if (!this.showButtonBulkUnclaim) {
                localOptions = this.bulkActions.filter(elem => elem.value !== "UNCLAIM");
            }
            if (!this.showButtonBulkReassign) {
                localOptions = this.bulkActions.filter(elem => elem.value !== "REASSIGN");
            }
            if (this.showButtonBulkUnclaim && this.showButtonBulkReassign) {
                localOptions = this.bulkActions;
            }
            return localOptions;
        },
        hasFilters() {
            if (this.nameValue === this.$t("tasks.myTeamTasks") || this.nameValue === this.$t("tasks.myTeamCompletedTasks")) {
                return true;
            }
            const checkSortUsersApps = this.tasksDisplayPayload.sortBy !== "" || !!this.tasksDisplayPayload.users.length;
            return checkSortUsersApps || !!this.tasksDisplayPayload.applications.length || !!this.tasksDisplayPayload.processes.length
            || !!this.tasksDisplayPayload.statuses.length || this.taskTypeValue;
        }
    },
    watch: {
        nameValue: {
            handler() {
                this.tasksDisplayPayload.pageNumber = 0;
                this.searchTasks = "";
                this.bulkTypeSelected = null;
                if (this.nameValue === this.$t("tasks.myOpenTasks")) {
                    this.tasksDisplayPayload.type = "myOpenTasks";
                    this.tasksDisplayPayload.activeTasks = true;
                    this.isOpen = true;
                    this.isTeam = false;
                    this.sortByData = this.sortByDataOpen;
                    this.getAllTasks(false);
                } else if (this.nameValue === this.$t("tasks.myCompletedTasks")) {
                    this.tasksDisplayPayload.type = "completedTasks";
                    this.tasksDisplayPayload.activeTasks = false;
                    this.isOpen = false;
                    this.isTeam = false;
                    this.sortByData = this.sortByDataCompleted;
                    this.getAllTasks(false);
                } else if (this.nameValue === this.$t("tasks.myTeamTasks")) {
                    this.getCurrentTasks();
                    this.tasksDisplayPayload.type = "teamsTasks";
                    this.tasksDisplayPayload.activeTasks = true;
                    this.isOpen = true;
                    this.isTeam = true;
                    this.sortByData = this.sortByDataOpen;
                } else if (this.nameValue === this.$t("tasks.myTeamCompletedTasks")) {
                    this.getCurrentTasks();
                    this.tasksDisplayPayload.type = "completedTeamsTasks";
                    this.tasksDisplayPayload.activeTasks = false;
                    this.isOpen = false;
                    this.isTeam = true;
                    this.sortByData = this.sortByDataCompleted;
                }
                this.resetFilters();
            }
        },
        searchTasks(newValue) {
            if (!newValue || (newValue && newValue.length > 2)) {
                this.loading = false;
                this.searchAllTasks();
            }
            if (newValue) {
                this.normalFont = true;
            }
        },
        appsData: {
            handler(value) {
                this.hasApps = !!(value && value.length);
            },
            immediate: true
        },
        processesData: {
            handler(value) {
                this.hasProcesses = !!(value && value.length);
            },
            immediate: true
        },
        "$backendDrivenEvents.state.refreshTasks": function (v) {
            if (v) {
                this.getAllTasks(false);
                this.tasksDisplayPayload.pageNumber = 0;
                this.$backendDrivenEvents.state.refreshTasks = false;
            }
        }
    },
    created() {
        this.getUserDetails().then((data) => {
            localStorage.setItem("accessibility", data.colorsAccessibility);
            const hasAccFeature = localStorage.getItem("accessibilityFeature");
            allowAccessibilityColors(data.colorsAccessibility && hasAccFeature === "true");
            this.tasksTypeData = this.getUserIsManager ? this.tasksTypeManager : this.tasksTypeNormalUser;
        });
        this.getCurrentTasks();
        const isCompleted = localStorage.getItem("isCompleted");
        const groupIdCopy = localStorage.getItem("groupIdCopy");
        this.tasksDisplayPayload.applications = this.getSelectedTasksFilter.applications || [];
        this.tasksDisplayPayload.processes = this.getSelectedTasksFilter.processes || [];
        if (this.getSelectedTasksFilter.applications && this.getSelectedAppName) {
            this.initialObject.applicationsValue.id = this.getSelectedTasksFilter.applications;
            this.initialObject.applicationsValue.name = this.getSelectedAppName;
        }
        if (this.getSelectedTasksFilter.processes) {
            this.initialObject.processesValue.id = this.getSelectedTasksFilter.processes;
            this.initialObject.processesValue.name = this.getSelectedAppName;
        }
        if (isCompleted === "completedTasks") {
            this.nameValue = this.$t("tasks.myCompletedTasks");
            this.targetTypeTaskList = this.$t("tasks.myCompletedTasks");
        } else if (isCompleted === "openTeamsTasks") {
            this.nameValue = this.$t("tasks.myTeamTasks");
            this.targetTypeTaskList = this.$t("tasks.myTeamTasks");
            this.tasksDisplayPayload.type = "teamsTasks";
            this.tasksDisplayPayload.groupId = groupIdCopy;
        } else if (isCompleted === "completedTeamsTasks") {
            this.nameValue = this.$t("tasks.myTeamCompletedTasks");
            this.targetTypeTaskList = this.$t("tasks.myTeamCompletedTasks");
            this.tasksDisplayPayload.type = "completedTeamsTasks";
            this.tasksDisplayPayload.groupId = groupIdCopy;
        }
        this.getAppsList();
        this.getUsersList();
        this.getAllTasks(false);
        this.sortByData = this.sortByDataOpen;
        this.searchAllTasks = debounce(() => {
            this.lastScrollTop = 0;
            this.tasksDisplayPayload.searchValue = this.searchTasks ? this.searchTasks.trim() : "";
            this.tasksDisplayPayload.pageNumber = 0;
            this.getAllTasks();
        }, 200);

        this.getAllApps();
    },
    updated() {
        if (this.nameValue === this.$t("tasks.myOpenTasks")) {
            this.tasksDisplayPayload.type = "myOpenTasks";
        }
    },
    methods: {
        ...mapActions("tasks", ["getAllFilteredTasks", "getUserDetails", "getMyTeamGroups"]),
        ...mapActions("apps", ["getAllApps", "getAppsWithPagination", "getAppProcesses"]),
        ...mapActions("admin", ["getUsersList"]),
        unclaimReassignResponse() {
            this.cancelBulk();
            this.refreshTasksDataList();
        },
        selectBulkOption($event) {
            if ($event && $event.length) {
                this.bulkOptionActionSelected($event[0].value);
            }
        },
        openDialog() {
            this.tasksTypeDialog = true;
        },
        openUsersModal() {
            this.allUsers = this.hasUsers;
        },
        openAppsModal() {
            this.allApplications = this.hasApps;
        },
        openProcessesModal() {
            if (this.selectedApplications.name) {
                this.allProcesses = this.hasProcesses;
            }
        },
        resetFilters() {
            this.lastScrollTop = 0;
            this.resetMyFilters = true;
            this.usersValue = "";
            this.applicationsValue = "";
            this.processesValue = "";
            this.selectedProcessesToSend = [];
            this.statusesValue = "";
            this.sortValue = "";
            this.selectedApplications.id = [];
            this.selectedApplications.name = "";
            this.selectedProcesses.id = [];
            this.selectedProcesses.name = "";
            const resettingPayload = {
                sortBy: "",
                sortType: "",
                users: [],
                applications: [],
                processes: [],
                statuses: []
            };
            this.tasksDisplayPayload = Object.assign(this.tasksDisplayPayload, resettingPayload);
        },
        showFiltersModal() {
            this.localShowFilters = true;
            if (this.resetMyFilters) {
                this.usersValue = "";
                this.applicationsValue = "";
                this.processesValue = "";
                this.statusesValue = "";
                this.sortValue = "";
                this.groupsValue = this.groupDefaultName;
                this.propGroups = {};
                this.propUsers = {};
                this.propStatuses = {};
                this.propSort = {};
                this.propTasks = {};
                this.propApp = {};
                this.propProcesses = {};
                this.initialObject = JSON.parse(JSON.stringify(this.emptyInitialObject));
                this.selectedApplications.id = [];
                this.selectedApplications.name = "";
                this.selectedProcesses.id = [];
                this.selectedProcesses.name = "";
                this.selectedUsers.id = [];
                this.selectedUsers.name = "";
                this.selectedUsers.email = [];
                this.selectedSort.by = "";
                this.selectedSort.type = "";
                this.selectedStatuses.id = [];
                this.selectedStatuses.statusesNames = "";
                this.sortingSelected = "";
            } else {
                this.sortValue = this.initialObject.sortingSelected;
                this.applicationsValue = this.initialObject.applicationsValue.name;
                this.taskTypeValue = this.initialObject.taskTypeValue.name;
                this.statusesValue = this.initialObject.statusesValue.statusName;
                this.usersValue = this.initialObject.usersValue.name;
                this.groupsValue = this.initialObject.groupsValue.name || this.groupDefaultName;

                this.propApp = this.initialObject.applicationsValue;
                this.propProcesses = this.initialObject.processesValue;
                this.propSort = this.initialObject.sort;
                this.propStatuses = this.initialObject.statusesValue;
                this.propTasks = this.initialObject.taskTypeValue;
                this.propUsers = this.initialObject.usersValue;
                this.propGroups = this.initialObject.groupsValue;
            }
            this.resetMyFilters = false;
        },
        selectTasksType(value) {
            this.nameValue = value;
            this.tasksTypeDialog = false;
            this.cancelBulk();
        },
        selectSort(element) {
            this.sortValue = this.$t(element.name);
            this.sortingSelected = this.sortValue;
            this.selectedSort.by = element.value;
            this.selectedSort.type = element.type;
        },
        selectFilters(value) {
            this.statusesValue = "";
            this.selectedStatuses = {
                id: [],
                statusesNames: ""
            };
            const namesToBeDisplayed = [];
            value.forEach((element) => {
                namesToBeDisplayed.push(PRIORITY_MAPPINGS[element.name]);
                this.selectedStatuses.id.push(element.id);
            });
            this.statusesValue = namesToBeDisplayed.join(", ");
            this.selectedStatuses.statusesNames = this.statusesValue;
        },
        selectTasks(value) {
            const namesToBeDisplayed = [];
            this.selectedTasks = {
                id: [],
                name: ""
            };
            value.forEach((element) => {
                namesToBeDisplayed.push(TASK_TYPE_MAPPINGS[element.name]);
                this.selectedTasks.id.push(element.id);
            });
            this.taskTypeValue = namesToBeDisplayed.join(", ");
            this.selectedTasks.name = this.taskTypeValue;
        },
        selectApplications(value) {
            const namesToBeDisplayed = [];
            this.processesData = [];
            this.selectedProcessesToSend = [];
            this.propProcesses = {};
            this.selectedApplications = {
                id: [],
                name: ""
            };
            this.processesValue = "";
            this.selectedProcesses = {
                id: [],
                name: ""
            };
            value.forEach((element) => {
                if (element.id) {
                    namesToBeDisplayed.push(element.name);
                    this.selectedApplications.id.push(element.id);
                }
            });
            this.selectedApplications.id.forEach(app => {
                this.getAppProcesses({ applicationId: app, searchTerm: "" }).then(rsp => {
                    if (rsp.data) {
                        rsp.data.forEach(item => {
                            this.processesData.push({ name: item.name, id: item.id });
                        });
                    }
                });
            });

            this.applicationsValue = namesToBeDisplayed.join(", ");
            this.selectedApplications.name = this.applicationsValue;
        },
        selectProcesses(value) {
            const namesToBeDisplayed = [];
            this.selectedProcesses = {
                id: [],
                name: ""
            };
            this.selectedProcessesToSend = value;
            value.forEach((element) => {
                if (element.id) {
                    namesToBeDisplayed.push(element.name);
                    this.selectedProcesses.id.push(element.id);
                }
            });
            this.processesValue = namesToBeDisplayed.join(", ");
            this.selectedProcesses.name = this.processesValue;
        },
        getCurrentTasks() {
            if (this.userDataDetails.manager) {
                this.getMyTeamGroups(this.userDataDetails.id).then(
                    data => {
                        this.dataGroups = data || [];
                        this.tasksDisplayPayload.groupId = this.dataGroups[0] ? this.dataGroups[0].id : "";
                        this.selectedGroup.id = this.tasksDisplayPayload.groupId;
                        localStorage.setItem("groupIdCopy", this.tasksDisplayPayload.groupId);
                        this.groupsValue = this.dataGroups[0] ? this.dataGroups[0].name : "";
                        this.initialObject.groupsValue.name = this.groupsValue;
                        this.selectedGroup.name = this.groupsValue;
                        this.groupDefaultName = this.groupsValue;
                        this.getAllTasks(false);
                    }
                );
            }
        },
        selectUsers(value) {
            const namesToBeDisplayed = [];
            this.selectedUsers = {
                id: [],
                name: "",
                email: []
            };
            value.forEach((element) => {
                namesToBeDisplayed.push(element.name);
                this.selectedUsers.id.push(element.id);
                this.selectedUsers.email.push(element.email);
            });
            this.usersValue = namesToBeDisplayed.join(", ");
            this.selectedUsers.name = this.usersValue;
            this.resetUser = false;
        },
        selectGroup(value) {
            this.groupsValue = value.name;
            this.selectedGroup.name = this.groupsValue;
            this.resetUser = true;
            this.selectedUsers = {
                id: [],
                name: "",
                email: []
            };
            this.selectedGroup.id = value.id;
            this.tasksDisplayPayload.groupId = this.selectedGroup.id;
            this.getAllFilteredTasks(this.tasksDisplayPayload).then(data => {
                if (data.users) {
                    this.userList = data.users;
                }
                this.hasUsers = !!this.userList.length;
            });
            this.usersValue = "";
        },
        bulkOptionActionSelected(selection) {
            this.allTasksListIds = [];
            if (selection) {
                this.taskList.forEach(item => {
                    if ((selection === "UNCLAIM" && item.canUnclaim) || (selection === "REASSIGN" && item.canReassign)) {
                        this.allTasksListIds.push(item.taskId);
                    }
                });
            }

            this.bulkTypeSelected = selection;
            this.bulkCheckbox = false;
            this.entireSelectedTaskList = [];
        },
        cancelBulk() {
            this.tasksChecked = false;
            this.bulkTypeSelected = null;
            this.bulkCheckbox = false;
            this.entireSelectedTaskList = [];
            this.bulkCheckboxSelectedTasks = [];
            this.resetSelectedBackground = true;
            this.hasIndeterminate = false;
            this.bulkActionsModel = [];
        },
        getAllTasks(loadMore) {
            if (!this.loading) {
                this.loading = true;
                if (this.tasksDisplayPayload.type === "myOpenTasks" || this.tasksDisplayPayload.type === "completedTasks") {
                    this.tasksDisplayPayload.groupId = "";
                }
                this.getAllFilteredTasks(this.tasksDisplayPayload).then(data => {
                    let allTasks = [];
                    if (data.users) {
                        this.userList = data.users;
                        this.hasUsers = !!this.userList.length;
                    }
                    if (!loadMore) {
                        this.showButtonBulkUnclaim = false;
                        this.showButtonBulkReassign = false;
                        this.taskList = this.returnData(data.tasks);
                    }
                    if (data.tasks) {
                        allTasks = data.tasks.map((current) => {
                            if (current.canUnclaim && !this.showButtonBulkUnclaim) {
                                this.showButtonBulkUnclaim = true;
                            }
                            if (current.canReassign && !this.showButtonBulkReassign) {
                                this.showButtonBulkReassign = true;
                            }

                            const allFilteredTasks = this.transformData(current);
                            if (this.bulkTypeSelected) {
                                const bulkUnclaim = (this.bulkTypeSelected === "UNCLAIM" && allFilteredTasks.canUnclaim);
                                if (bulkUnclaim || (this.bulkTypeSelected === "REASSIGN" && allFilteredTasks.canReassign)) {
                                    this.allTasksListIds.push(allFilteredTasks.taskId);
                                }
                            }
                            return allFilteredTasks;
                        });
                    }
                    if (loadMore) {
                        this.taskList = this.taskList.concat(this.returnData(data.tasks));
                    } else {
                        this.taskList = allTasks || [];
                    }

                    this.totalCount = data.totalCount;
                    this.loading = false;
                });
            }
            localStorage.removeItem("isCompleted");
        },
        selectedTasksList(event) {
            if (event) {
                this.entireSelectedTaskList = event.listData;
                if (typeof event.bulkCheck === "boolean" || event.bulkCheck === "indeterminate-check") {
                    this.tasksChecked = event.bulkCheck;
                    this.bulkCheckbox = event.bulkCheck || "indeterminate-check";
                    if (this.bulkCheckbox === "indeterminate-check") {
                        if (this.entireSelectedTaskList.length) {
                            this.hasIndeterminate = true;
                        } else {
                            this.hasIndeterminate = false;
                            this.bulkCheckbox = false;
                        }
                    } else {
                        this.hasIndeterminate = false;
                        this.bulkCheckbox = true;
                    }
                } else {
                    this.hasIndeterminate = false;
                }
            }
        },
        openUnclaimReassignModalAction() {
            if (this.entireSelectedTaskList.length) {
                this.bulkActionsModel = [];
                this.bulkUnclaimReassignModal = true;
            }
        },
        returnData(data) {
            const dataToReturn = [];
            data.forEach(element => {
                dataToReturn.push(this.transformData(element));
            });
            return dataToReturn;
        },
        loadMoreTasks() {
            const { header, subheader, layout, tasksContainer } = this.$refs;
            const st = layout.scrollTop;
            const maintenanceMsg = document.getElementById("maintenanceMsg");
            if (st > this.elemScroll) {
                header.style.position = "relative";
                subheader.style.top = "0px";
            } else {
                header.style.position = "fixed";
                header.style.top = maintenanceMsg ? maintenanceMsg.style.top : "0";
                subheader.style.top = "58px";
                tasksContainer.style.marginTop = "58px";
                header.style.width = `${subheader.style.width}px`;
            }
            this.elemScroll = st <= 0 ? 0 : st;
            setTimeout(() => {
                if (layout.scrollTop - this.lastScrollTop > 140 && layout.scrollTop + layout.offsetHeight >= layout.scrollHeight - 30) {
                    this.lastScrollTop = layout.scrollTop;
                    this.tasksDisplayPayload.pageNumber++;
                    this.getAllTasks(true);
                }
            }, 500);
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        modalAction($event) {
            if ($event === "primary") {
                this.initialObject.sort.by = this.selectedSort.by;
                this.initialObject.sort.type = this.selectedSort.type;
                this.initialObject.sortingSelected = this.sortingSelected;

                this.initialObject.statusesValue.id = this.selectedStatuses.id;
                this.initialObject.statusesValue.statusName = this.selectedStatuses.statusesNames;

                this.initialObject.taskTypeValue.id = this.selectedTasks.id;
                this.initialObject.taskTypeValue.name = this.selectedTasks.name;

                this.initialObject.applicationsValue.id = this.selectedApplications.id;
                this.initialObject.applicationsValue.name = this.selectedApplications.name;

                this.initialObject.processesValue.id = this.selectedProcesses.id;
                this.initialObject.processesValue.name = this.selectedProcesses.name;

                this.initialObject.usersValue.id = this.selectedUsers.id;
                this.initialObject.usersValue.name = this.selectedUsers.name;
                this.initialObject.usersValue.email = this.selectedUsers.email;

                this.initialObject.groupsValue.id = this.selectedGroup.id;
                this.initialObject.groupsValue.name = this.selectedGroup.name;

                this.tasksDisplayPayload.sortBy = this.initialObject.sort.by;
                this.tasksDisplayPayload.sortType = this.initialObject.sort.type;
                this.tasksDisplayPayload.applications = this.initialObject.applicationsValue.id;
                this.tasksDisplayPayload.processes = this.initialObject.processesValue.id;
                if (this.initialObject.taskTypeValue.id.length === 2 || !this.initialObject.taskTypeValue.id.length) {
                    this.tasksDisplayPayload.onlyClaimed = false;
                    this.tasksDisplayPayload.onlyAvailable = false;
                    this.tasksDisplayPayload.onlyDelegated = false;
                } else if (this.initialObject.taskTypeValue.id.length === 1) {
                    if (this.initialObject.taskTypeValue.id[0] === "Claimed") {
                        this.tasksDisplayPayload.onlyClaimed = true;
                        this.tasksDisplayPayload.onlyAvailable = false;
                        this.tasksDisplayPayload.onlyDelegated = false;
                    } else if (this.initialObject.taskTypeValue.id[0] === "Available") {
                        this.tasksDisplayPayload.onlyClaimed = false;
                        this.tasksDisplayPayload.onlyAvailable = true;
                        this.tasksDisplayPayload.onlyDelegated = false;
                    } else {
                        this.tasksDisplayPayload.onlyClaimed = false;
                        this.tasksDisplayPayload.onlyAvailable = false;
                        this.tasksDisplayPayload.onlyDelegated = true;
                    }
                }
                this.tasksDisplayPayload.statuses = this.initialObject.statusesValue.id;
                this.tasksDisplayPayload.users = this.initialObject.usersValue.id;

                if (this.tasksDisplayPayload.type === "myOpenTasks" || this.tasksDisplayPayload.type === "completedTasks") {
                    this.tasksDisplayPayload.groupId = "";
                } else {
                    this.tasksDisplayPayload.groupId = this.initialObject.groupsValue.id;
                }

                this.lastScrollTop = 0;
                this.tasksDisplayPayload.pageNumber = 0;
                this.getAllTasks();
            } else {
                const groupIdCopy = localStorage.getItem("groupIdCopy");
                if (groupIdCopy !== this.tasksDisplayPayload.groupId) {
                    this.tasksDisplayPayload.groupId = groupIdCopy;
                }
            }
            this.localShowFilters = false;
        },
        selectAllTasks(data) {
            this.bulkCheckboxSelectedTasks = data ? [...this.allTasksListIds] : [];
            if (this.entireSelectedTaskList.length) {
                if (this.tasksChecked) {
                    this.tasksChecked = false;
                } else {
                    this.entireSelectedTaskList = [];
                }
            } else {
                this.tasksChecked = true;
            }
        },
        getAppsList(loadmore) {
            if (loadmore) {
                this.appsPayload.pageNumber++;
            } else {
                this.appsPayload.pageNumber = 0;
            }
            this.getAppsWithPagination(this.appsPayload).then(data => {
                this.appsData = loadmore ? [...this.appsData, ...data] : [...data];
            });
        },
        loadMoreApps(load) {
            if (load) {
                this.getAppsList(true);
            }
        }
    }
};
